<script>
    import { theme } from "$lib/utils/theme.svelte.ts";
</script>

<!-- Small smokey cloud wisps — fixed-size, absolutely positioned -->
<div
    class="cloud-layer"
    class:light={theme.resolved === "light"}
    aria-hidden="true"
>
    <div class="clouds clouds--far">
        <svg class="wisp w1" viewBox="0 0 120 75"
            ><path
                d="M91 31.5c-.53-11.87-10.11-21.36-22.07-21.36-4.1 0-7.97 1.06-11.32 2.94C57.01 6.83 49.15 1.5 40 1.5 25 1.5 12.86 13.63 12.86 28.63c0 .69.03 1.38.08 2.06C5.55 33.42 0 41.45 0 50.69 0 63.42 10.31 73.73 23.04 73.73H91c15 0 27.17-12.16 27.17-27.17 0-15.01-12.17-27.06-27.17-27.06Z"
            /></svg
        >
        <svg class="wisp w2" viewBox="0 0 76 50"
            ><path
                d="M58 22c-.4-7.8-6.7-14-14.5-14-2.7 0-5.2.7-7.4 1.9C34 5.5 29 2 23.2 2 14.5 2 7.3 9 7.3 17.7c0 .5 0 1 .05 1.4C3 21.2 0 26.5 0 32.5 0 41 6.8 47.8 15.2 47.8H58c9.9 0 17.9-8 17.9-17.9S67.9 12 58 12c0 3.4.2 6.7 0 10Z"
            /></svg
        >
        <svg class="wisp w3" viewBox="0 0 120 75"
            ><path
                d="M91 31.5c-.53-11.87-10.11-21.36-22.07-21.36-4.1 0-7.97 1.06-11.32 2.94C57.01 6.83 49.15 1.5 40 1.5 25 1.5 12.86 13.63 12.86 28.63c0 .69.03 1.38.08 2.06C5.55 33.42 0 41.45 0 50.69 0 63.42 10.31 73.73 23.04 73.73H91c15 0 27.17-12.16 27.17-27.17 0-15.01-12.17-27.06-27.17-27.06Z"
            /></svg
        >
        <svg class="wisp w4" viewBox="0 0 76 50"
            ><path
                d="M58 22c-.4-7.8-6.7-14-14.5-14-2.7 0-5.2.7-7.4 1.9C34 5.5 29 2 23.2 2 14.5 2 7.3 9 7.3 17.7c0 .5 0 1 .05 1.4C3 21.2 0 26.5 0 32.5 0 41 6.8 47.8 15.2 47.8H58c9.9 0 17.9-8 17.9-17.9S67.9 12 58 12c0 3.4.2 6.7 0 10Z"
            /></svg
        >
        <svg class="wisp w5" viewBox="0 0 120 75"
            ><path
                d="M91 31.5c-.53-11.87-10.11-21.36-22.07-21.36-4.1 0-7.97 1.06-11.32 2.94C57.01 6.83 49.15 1.5 40 1.5 25 1.5 12.86 13.63 12.86 28.63c0 .69.03 1.38.08 2.06C5.55 33.42 0 41.45 0 50.69 0 63.42 10.31 73.73 23.04 73.73H91c15 0 27.17-12.16 27.17-27.17 0-15.01-12.17-27.06-27.17-27.06Z"
            /></svg
        >
    </div>

    <div class="clouds clouds--mid">
        <svg class="wisp w6" viewBox="0 0 76 50"
            ><path
                d="M58 22c-.4-7.8-6.7-14-14.5-14-2.7 0-5.2.7-7.4 1.9C34 5.5 29 2 23.2 2 14.5 2 7.3 9 7.3 17.7c0 .5 0 1 .05 1.4C3 21.2 0 26.5 0 32.5 0 41 6.8 47.8 15.2 47.8H58c9.9 0 17.9-8 17.9-17.9S67.9 12 58 12c0 3.4.2 6.7 0 10Z"
            /></svg
        >
        <svg class="wisp w7" viewBox="0 0 120 75"
            ><path
                d="M91 31.5c-.53-11.87-10.11-21.36-22.07-21.36-4.1 0-7.97 1.06-11.32 2.94C57.01 6.83 49.15 1.5 40 1.5 25 1.5 12.86 13.63 12.86 28.63c0 .69.03 1.38.08 2.06C5.55 33.42 0 41.45 0 50.69 0 63.42 10.31 73.73 23.04 73.73H91c15 0 27.17-12.16 27.17-27.17 0-15.01-12.17-27.06-27.17-27.06Z"
            /></svg
        >
        <svg class="wisp w8" viewBox="0 0 76 50"
            ><path
                d="M58 22c-.4-7.8-6.7-14-14.5-14-2.7 0-5.2.7-7.4 1.9C34 5.5 29 2 23.2 2 14.5 2 7.3 9 7.3 17.7c0 .5 0 1 .05 1.4C3 21.2 0 26.5 0 32.5 0 41 6.8 47.8 15.2 47.8H58c9.9 0 17.9-8 17.9-17.9S67.9 12 58 12c0 3.4.2 6.7 0 10Z"
            /></svg
        >
        <svg class="wisp w9" viewBox="0 0 120 75"
            ><path
                d="M91 31.5c-.53-11.87-10.11-21.36-22.07-21.36-4.1 0-7.97 1.06-11.32 2.94C57.01 6.83 49.15 1.5 40 1.5 25 1.5 12.86 13.63 12.86 28.63c0 .69.03 1.38.08 2.06C5.55 33.42 0 41.45 0 50.69 0 63.42 10.31 73.73 23.04 73.73H91c15 0 27.17-12.16 27.17-27.17 0-15.01-12.17-27.06-27.17-27.06Z"
            /></svg
        >
        <svg class="wisp w10" viewBox="0 0 76 50"
            ><path
                d="M58 22c-.4-7.8-6.7-14-14.5-14-2.7 0-5.2.7-7.4 1.9C34 5.5 29 2 23.2 2 14.5 2 7.3 9 7.3 17.7c0 .5 0 1 .05 1.4C3 21.2 0 26.5 0 32.5 0 41 6.8 47.8 15.2 47.8H58c9.9 0 17.9-8 17.9-17.9S67.9 12 58 12c0 3.4.2 6.7 0 10Z"
            /></svg
        >
    </div>

    <div class="clouds clouds--near">
        <svg class="wisp w11" viewBox="0 0 76 50"
            ><path
                d="M58 22c-.4-7.8-6.7-14-14.5-14-2.7 0-5.2.7-7.4 1.9C34 5.5 29 2 23.2 2 14.5 2 7.3 9 7.3 17.7c0 .5 0 1 .05 1.4C3 21.2 0 26.5 0 32.5 0 41 6.8 47.8 15.2 47.8H58c9.9 0 17.9-8 17.9-17.9S67.9 12 58 12c0 3.4.2 6.7 0 10Z"
            /></svg
        >
        <svg class="wisp w12" viewBox="0 0 120 75"
            ><path
                d="M91 31.5c-.53-11.87-10.11-21.36-22.07-21.36-4.1 0-7.97 1.06-11.32 2.94C57.01 6.83 49.15 1.5 40 1.5 25 1.5 12.86 13.63 12.86 28.63c0 .69.03 1.38.08 2.06C5.55 33.42 0 41.45 0 50.69 0 63.42 10.31 73.73 23.04 73.73H91c15 0 27.17-12.16 27.17-27.17 0-15.01-12.17-27.06-27.17-27.06Z"
            /></svg
        >
        <svg class="wisp w13" viewBox="0 0 76 50"
            ><path
                d="M58 22c-.4-7.8-6.7-14-14.5-14-2.7 0-5.2.7-7.4 1.9C34 5.5 29 2 23.2 2 14.5 2 7.3 9 7.3 17.7c0 .5 0 1 .05 1.4C3 21.2 0 26.5 0 32.5 0 41 6.8 47.8 15.2 47.8H58c9.9 0 17.9-8 17.9-17.9S67.9 12 58 12c0 3.4.2 6.7 0 10Z"
            /></svg
        >
        <svg class="wisp w14" viewBox="0 0 120 75"
            ><path
                d="M91 31.5c-.53-11.87-10.11-21.36-22.07-21.36-4.1 0-7.97 1.06-11.32 2.94C57.01 6.83 49.15 1.5 40 1.5 25 1.5 12.86 13.63 12.86 28.63c0 .69.03 1.38.08 2.06C5.55 33.42 0 41.45 0 50.69 0 63.42 10.31 73.73 23.04 73.73H91c15 0 27.17-12.16 27.17-27.17 0-15.01-12.17-27.06-27.17-27.06Z"
            /></svg
        >
    </div>
</div>

<style>
    .cloud-layer {
        position: fixed;
        inset: 0;
        z-index: -1;
        pointer-events: none;
        --cloud-fill: #ffffff;
        --cloud-shadow: rgba(113, 138, 158, 0.42);
        --cloud-glow: rgba(255, 255, 255, 0.7);
        opacity: 0;
        transition: opacity 0.8s ease;
        mix-blend-mode: normal;
    }

    .cloud-layer.light {
        opacity: 0.92;
    }

    .clouds {
        position: absolute;
        inset: 0;
    }

    .wisp {
        position: absolute;
        fill: var(--cloud-fill);
        filter: blur(6px) drop-shadow(0 0 10px var(--cloud-glow))
            drop-shadow(0 8px 16px var(--cloud-shadow));
        --s: 2.9;
        transform: translate(0, 0) scale(var(--s));
        transform-origin: center;
        transform-box: fill-box;
    }

    .w1 {
        width: 90px;
        top: 8%;
        left: 5%;
        opacity: 0.84;
        animation: drift-a 22s ease-in-out infinite;
    }
    .w2 {
        width: 55px;
        top: 15%;
        left: 35%;
        opacity: 0.8;
        animation: drift-b 28s ease-in-out infinite;
    }
    .w3 {
        width: 75px;
        top: 5%;
        left: 65%;
        opacity: 0.83;
        animation: drift-c 25s ease-in-out infinite;
    }
    .w4 {
        width: 50px;
        top: 45%;
        left: 15%;
        opacity: 0.81;
        animation: drift-b 30s ease-in-out infinite;
    }
    .w5 {
        width: 80px;
        top: 55%;
        left: 80%;
        opacity: 0.8;
        animation: drift-a 26s ease-in-out infinite;
    }

    .w6 {
        width: 60px;
        top: 20%;
        left: 22%;
        opacity: 0.88;
        animation: drift-c 18s ease-in-out infinite;
    }
    .w7 {
        width: 70px;
        top: 12%;
        left: 52%;
        opacity: 0.87;
        animation: drift-a 24s ease-in-out infinite;
    }
    .w8 {
        width: 45px;
        top: 38%;
        left: 75%;
        opacity: 0.82;
        animation: drift-b 20s ease-in-out infinite;
    }
    .w9 {
        width: 65px;
        top: 60%;
        left: 40%;
        opacity: 0.86;
        animation: drift-c 22s ease-in-out infinite;
    }
    .w10 {
        width: 50px;
        top: 72%;
        left: 10%;
        opacity: 0.82;
        animation: drift-a 27s ease-in-out infinite;
    }

    .clouds--near .wisp {
        filter: blur(4px) drop-shadow(0 0 8px var(--cloud-glow))
            drop-shadow(0 7px 14px var(--cloud-shadow));
    }
    .w11 {
        width: 40px;
        top: 10%;
        left: 45%;
        opacity: 0.9;
        animation: drift-b 16s ease-in-out infinite;
    }
    .w12 {
        width: 50px;
        top: 30%;
        left: 88%;
        opacity: 0.88;
        animation: drift-c 19s ease-in-out infinite;
    }
    .w13 {
        width: 35px;
        top: 50%;
        left: 55%;
        opacity: 0.89;
        animation: drift-a 17s ease-in-out infinite;
    }
    .w14 {
        width: 45px;
        top: 78%;
        left: 70%;
        opacity: 0.86;
        animation: drift-b 21s ease-in-out infinite;
    }

    @keyframes drift-a {
        0%,
        100% {
            transform: translate(0, 0) scale(var(--s));
        }
        25% {
            transform: translate(24px, -16px) scale(var(--s));
        }
        50% {
            transform: translate(-12px, 20px) scale(var(--s));
        }
        75% {
            transform: translate(18px, 8px) scale(var(--s));
        }
    }
    @keyframes drift-b {
        0%,
        100% {
            transform: translate(0, 0) scale(var(--s));
        }
        25% {
            transform: translate(-18px, 12px) scale(var(--s));
        }
        50% {
            transform: translate(14px, -14px) scale(var(--s));
        }
        75% {
            transform: translate(-10px, 22px) scale(var(--s));
        }
    }
    @keyframes drift-c {
        0%,
        100% {
            transform: translate(0, 0) scale(var(--s));
        }
        25% {
            transform: translate(12px, 18px) scale(var(--s));
        }
        50% {
            transform: translate(-22px, -10px) scale(var(--s));
        }
        75% {
            transform: translate(16px, -8px) scale(var(--s));
        }
    }

    @supports (animation-timeline: scroll()) {
        .clouds--far {
            animation: parallax-far linear both;
            animation-timeline: scroll(root);
            animation-range: 0% 100%;
            will-change: transform;
        }
        .clouds--mid {
            animation: parallax-mid linear both;
            animation-timeline: scroll(root);
            animation-range: 0% 100%;
            will-change: transform;
        }
        .clouds--near {
            animation: parallax-near linear both;
            animation-timeline: scroll(root);
            animation-range: 0% 100%;
            will-change: transform;
        }

        @keyframes parallax-far {
            from {
                transform: translateY(0);
            }
            to {
                transform: translateY(-50px);
            }
        }
        @keyframes parallax-mid {
            from {
                transform: translateY(0);
            }
            to {
                transform: translateY(-100px);
            }
        }
        @keyframes parallax-near {
            from {
                transform: translateY(0);
            }
            to {
                transform: translateY(-160px);
            }
        }
    }

    @media (prefers-reduced-motion: reduce) {
        .wisp,
        .clouds--far,
        .clouds--mid,
        .clouds--near {
            animation: none;
        }
    }
</style>
